const { default: Swal } = require('sweetalert2');


window.axios = require('axios');
window.axios.defaults.baseURL = process.env.MIX_APP_API;
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.axios.defaults.headers['crossDomain'] = true;
window.axios.defaults.headers['Access-Control-Allow-Origin'] = '*';

(function () {
    var jsContext = window.requestFormData;
    var buttonName = 'Request A Quote';

    let currentPath = document.location.pathname.toLowerCase();
    if (currentPath === '/cart.php' || currentPath === '/checkout') {
        let storeID = jsContext.storeId;
        let secureBaseURL = jsContext.secure_base_url;

        if (storeID && secureBaseURL) {
            window.axios.post('configurations', {
                store_id: storeID,
                secure_base_url: secureBaseURL
            }).then(function (response) {
                if (response.status === 200) {
                    let showOnData = response.data.show_on;
                    let showData = response.data.show;
                    let customerGroups = response.data.customer_groups;
                    let groups = response.data.groups;
                    let priceControl = response.data.price_control;
                    let minimumPrice = parseFloat(Number(response.data.minimum_price).toFixed(2));
                    let maximumPrice = parseFloat(Number(response.data.maximum_price).toFixed(2));
                    let customer = jsContext.customer;
                    let isCustomer = !!customer;
                    let customerGroupID = jsContext.customer_group_id;
                    let modalData = {name: undefined, email: undefined, phone: undefined, company: undefined};
                    buttonName = response.data.button_name;
                    window.axios.token = response.data.token;

                    if (customer) {
                        let customerName, customerEmail, phone, company;
                        if (customer.name && customer.name !== "") customerName = customer.name;
                        if (customer.email) customerEmail = customer.email;
                        if (customer.phone && customer.phone !== "") phone = customer.phone;
                        if (customer.shipping_address && customer.shipping_address.company && customer.shipping_address.company !== "") company = customer.shipping_address.company;
                        modalData = {name: customerName, email: customerEmail, phone: phone, company: company};
                    }

                    if (currentPath === '/cart.php') {
                        let grandTotal = jsContext.cart.grand_total.value;
                        if (showOnData && showOnData.includes('cart') && showData) {
                            if (showData.includes('guests') && showData.includes('registered')) {
                                if (isCustomer) {
                                    if (customerCheck(customerGroupID, customerGroups, groups) && priceCheck(grandTotal, minimumPrice, maximumPrice, priceControl)) {
                                        pushCSS();
                                        createRequestBtnOnCart();
                                        createModal(modalData);
                                    }
                                } else {
                                    if (priceCheck(grandTotal, minimumPrice, maximumPrice, priceControl)) {
                                        pushCSS();
                                        createRequestBtnOnCart();
                                        createModal(modalData);
                                    }
                                }
                            } else if (showData.includes('guests') && !showData.includes('registered')) {
                                if (!isCustomer && priceCheck(grandTotal, minimumPrice, maximumPrice, priceControl)) {
                                    pushCSS();
                                    createRequestBtnOnCart();
                                    createModal(modalData);
                                }
                            } else if (!showData.includes('guests') && showData.includes('registered')) {
                                if (
                                    isCustomer &&
                                    customerCheck(customerGroupID, customerGroups, groups) &&
                                    priceCheck(grandTotal, minimumPrice, maximumPrice, priceControl)
                                ) {
                                    pushCSS();
                                    createRequestBtnOnCart();
                                    createModal(modalData);
                                }
                            }
                        }
                    }

                    if (currentPath === '/checkout' && showOnData && showOnData.includes('checkout')) {
                        let checkoutID = jsContext.checkout_id;
                        let checkoutData = {
                            'isCustomer': isCustomer, 'customerGroupID': customerGroupID, 'minimumPrice': minimumPrice,
                            'maximumPrice': maximumPrice, 'showOnData': showOnData,
                            'showData': showData, 'customerGroups': customerGroups,
                            'groups': groups, 'priceControl': priceControl
                        };


                        var interval = setInterval(function () {
                            if (document.getElementsByClassName('layout-main').length > 0) {
                                clearInterval(interval);
                                pushSwal();
                                orderModalFunctionality(checkoutID, checkoutData, modalData);
                            }
                        });

                        // orderModalFunctionality(checkoutID, checkoutData, modalData);

                        // let observer = new MutationObserver(function (mutationsList, observer) {
                        //     for (let mutation of mutationsList) {
                        //         if (
                        //             mutation.addedNodes.length === 0 && mutation.type === 'childList' &&
                        //             mutation.nextSibling && mutation.nextSibling.className === 'checkout-steps' &&
                        //             mutation.target && mutation.target.className === 'layout-main'
                        //         ) {
                        //             console.log(mutation);
                        //             //
                        //             //             console.log(mutation);
                        //             //             orderModalFunctionality(checkoutID, checkoutData, modalData);
                        //             //             observer.disconnect();
                        //         }
                        //     }
                        // });
                        // observer.observe(document.querySelector('body'), {
                        //     attributes: true,
                        //     childList: true,
                        //     subtree: true
                        // });

                    }
                }
            });

            function pushCSS() {
                let cssURL = process.env.MIX_APP_URL+'/css/request-form-modal.css',
                    linkCSS = document.createElement('link');
                linkCSS.setAttribute('rel', 'stylesheet');
                linkCSS.setAttribute('type', 'text/css');
                linkCSS.setAttribute('href', cssURL);
                document.querySelector('head').append(linkCSS);
            }

            function pushSwal() {
                let url = 'https://cdn.jsdelivr.net/npm/sweetalert2@11';
                var script = document.createElement('script');
                script.src = url;
                document.head.appendChild(script);
            }

            function createModal(inputsData) {
                let requestModal = document.createElement('div'),
                    requestModalContainer = document.createElement('div'),
                    requestMainDiv = document.createElement('div'),
                    requestForm = document.createElement('form'),
                    submitButton = document.createElement('button'),
                    fieldSet = document.createElement('p'),
                    closeATag = document.createElement('a');

                let formInputData = [
                    {
                        name: 'o7-name-surname',
                        text: 'First Name & Last Name',
                        type: 'text',
                        tagName: 'input',
                        value: inputsData.name
                    },
                    {
                        name: 'o7-email-address',
                        text: 'Email Address',
                        type: 'email',
                        tagName: 'input',
                        value: inputsData.email
                    },
                    {name: 'o7-phone', text: 'Phone Number', type: 'text', tagName: 'input', value: inputsData.phone},
                    {
                        name: 'o7-company',
                        text: 'Company',
                        type: 'text',
                        tagName: 'input',
                        value: inputsData.company
                    },
                    {name: 'o7-comments', text: 'Comments', type: 'textarea', tagName: 'textarea'},
                ];

                requestModal.setAttribute('class', 'o7-request-modal');
                requestModalContainer.setAttribute('class', 'o7-request-modal-container');
                requestMainDiv.setAttribute('id', 'o7-request-main-div');
                requestForm.setAttribute('class', 'o7-request-form');

                fieldSet.setAttribute('class', 'fieldset');
                submitButton.setAttribute('type', 'button');
                submitButton.setAttribute('class', 'full-width has-padding submit-btn');
                submitButton.setAttribute('id', 'o7-submit-request-a-quote');
                submitButton.innerText = 'Submit';
                fieldSet.append(submitButton);

                formInputCreator(formInputData, requestForm);

                requestForm.append(fieldSet);
                requestMainDiv.append(requestForm);

                closeATag.setAttribute('class', 'o7-close-request-form')
                requestModalContainer.append(requestMainDiv);
                requestModalContainer.append(closeATag);

                requestModal.append(requestModalContainer);
                document.querySelector('body').append(requestModal);

                var $form_modal = document.getElementsByClassName('o7-request-modal')[0],
                    $form_signup = document.getElementById('o7-request-main-div'),
                    $tab_signup = document.getElementById('o7-open-modal-button'),
                    $submitBtn = document.getElementById('o7-submit-request-a-quote');

                $tab_signup.addEventListener("click", function (e) {
                    $form_modal.classList.add("is-visible");
                    $form_signup.classList.add("is-selected");
                    $tab_signup.classList.add("selected");
                }, false);

                $form_modal.addEventListener('click', function (event) {
                    if (event.target.classList.length > 0 && (event.target.classList.contains('o7-request-modal') || event.target.classList.contains('o7-close-request-form'))) {
                        $form_modal.classList.remove('is-visible');
                    }
                });

                $submitBtn.addEventListener('click', function (event) {
                    event.preventDefault();

                    formErrorMessages();

                    if($submitBtn.innerText == 'Sending...') {
                        return;
                    }

                    if (
                        document.getElementById('o7-name-surname').value !== "" &&
                        document.getElementById('o7-email-address').value !== "" &&
                        document.getElementById('o7-phone').value
                    ) {

                        $submitBtn.innerText = 'Sending...';

                        window.axios.get('/api/storefront/carts?include=lineItems.digitalItems.options,lineItems.physicalItems.options', {
                            baseURL: null
                        }).then(response => {
                            if (response.status === 200 && response.data.length > 0) {

                                jsContext.cart_id = response.data[0].id;
                                window.axios.post('form', {
                                    quote_data: {
                                        name: document.getElementById('o7-name-surname').value,
                                        email: document.getElementById('o7-email-address').value,
                                        phone: document.getElementById('o7-phone').value,
                                        company: document.getElementById('o7-company').value,
                                        comments: document.getElementById('o7-comments').value,
                                        token : window.axios.token
                                    },
                                    cart_data: response.data[0],
                                    store_information: {
                                        store_id: storeID,
                                        secure_base_url: secureBaseURL,
                                    },
                                    customer: jsContext.customer
                                }).then(function (response) {

                                    $form_modal.classList.remove('is-visible');

                                    showSwal(response.data);

                                    $submitBtn.innerText = 'Submit...';

                                });
                            }
                        });
                    }
                });

                document.addEventListener('keyup', function (event) {
                    if (event.key === 'Escape') {
                        $form_modal.classList.remove('is-visible');
                    }
                });

            }

            function formInputCreator(data, node) {
                for (let i = 0; i < data.length; i++) {
                    let fieldSet = document.createElement('p');
                    fieldSet.setAttribute('class', 'fieldset');

                    let label = document.createElement('label');
                    label.setAttribute('class', 'image-replace');
                    label.setAttribute('for', data[i].name);
                    label.innerText = data[i].text;

                    let textInput = document.createElement(data[i].tagName);
                    textInput.setAttribute('class', 'full-width has-padding has-border');
                    textInput.setAttribute('id', data[i].name);
                    textInput.setAttribute('name', data[i].name);
                    textInput.setAttribute('placeholder', data[i].text);

                    let errorSpan = document.createElement('span');
                    errorSpan.setAttribute('class', 'o7-error-message');

                    if (data[i].value) {
                        textInput.setAttribute('value', data[i].value);
                    }

                    if (data[i].type === 'textarea') {
                        textInput.setAttribute('cols', '30');
                        textInput.setAttribute('rows', '4');
                    }

                    fieldSet.append(label);
                    fieldSet.append(textInput);
                    fieldSet.append(errorSpan);

                    node.append(fieldSet);
                }
            }

            function createRequestBtnOnCart() {
                let checkoutButton = document.querySelectorAll('body')[0];
                if (checkoutButton) {

                    let buttonNode = document.createElement('a');
                    buttonNode.setAttribute('class', 'button');
                    buttonNode.setAttribute('id', 'o7-open-modal-button');
                    buttonNode.style.margin = "0 10px";
                    buttonNode.innerText = buttonName;

                    checkoutButton.parentElement.append(buttonNode);
                } else {
                    console.log('%c THERE IS NO CHECKOUT BUTTON ON THE CART PAGE!', 'background: #c7ff3f; color: #000; font-size: 12px');
                }
            }

            function createRequestBtnOnCheckout() {
                let selector = document.querySelectorAll('body')[0];
                if (selector) {
                    let buttonNode = document.createElement('button');
                    buttonNode.setAttribute('class', 'button button--primary');
                    buttonNode.setAttribute('id', 'o7-open-modal-button');
                    buttonNode.innerText = 'Request a Quote';
                    selector.prepend(buttonNode);
                }
            }

            function priceCheck(grandTotal, minimumPrice, maximumPrice, priceControl) {
                if (grandTotal > 0) {
                    if (priceControl === 'enable') {
                        if (minimumPrice > 0 && maximumPrice > 0) {
                            if (grandTotal >= minimumPrice && grandTotal <= maximumPrice) return true;
                        } else if (minimumPrice === 0 && maximumPrice > 0) {
                            if (grandTotal <= maximumPrice) return true;
                        } else if (minimumPrice > 0 && maximumPrice === 0) {
                            if (grandTotal >= minimumPrice) return true;
                        }
                    } else {
                        return true;
                    }
                }
                return false;
            }

            function customerCheck(bigCommerceCustomerGroupID, customerGroups, groups) {
                if (customerGroups !== 'all') {
                    if (bigCommerceCustomerGroupID > 0 && groups.includes(bigCommerceCustomerGroupID)) {
                        return true;
                    }
                } else {
                    return true;
                }
                return false;
            }

            function orderModalFunctionality(checkoutID, data, modalData) {
                if (checkoutID) {
                    window.axios.get('/api/storefront/checkout/' + checkoutID, {
                        credentials: 'include',
                        baseURL: null
                    }).then(response => {
                        if (response.status === 200) {
                            let checkoutGrandTotal = response.data.grandTotal;
                            let reqBtn = document.querySelector('button#o7-open-modal-button');
                            console.log('%c Checkout Page! ', 'background: #c7ff3f; color: #000; font-size: 12px');
                            console.log('%c Grand Total: ' + checkoutGrandTotal, 'background: #c7ff3f; color: #000; font-size: 12px');
                            console.log('%c Is Customer: ' + data.isCustomer, 'background: #c7ff3f; color: #000; font-size: 12px');
                            console.log('%c Customer Group ID: ' + data.customerGroupID, 'background: #c7ff3f; color: #000; font-size: 12px');
                            console.log('%c Minimum Price: ' + data.minimumPrice, 'background: #c7ff3f; color: #000; font-size: 12px');
                            console.log('%c Maximum Price: ' + data.maximumPrice, 'background: #c7ff3f; color: #000; font-size: 12px');

                            if (data.showOnData && data.showOnData.includes('cart') && data.showData) {
                                if (data.showData.includes('guests') && data.showData.includes('registered')) {
                                    if (data.isCustomer) {
                                        if (customerCheck(data.customerGroupID, data.customerGroups, data.groups) && priceCheck(checkoutGrandTotal, data.minimumPrice, data.maximumPrice, data.priceControl)) {
                                            pushCSS();
                                            if (reqBtn === null) {
                                                createRequestBtnOnCheckout();
                                            }
                                            createModal(modalData);
                                        }
                                    } else {
                                        if (priceCheck(checkoutGrandTotal, data.minimumPrice, data.maximumPrice, data.priceControl)) {
                                            pushCSS();
                                            if (reqBtn === null) {
                                                createRequestBtnOnCheckout();
                                            }
                                            createModal(modalData);
                                        }
                                    }
                                } else if (data.showData.includes('guests') && !data.showData.includes('registered')) {
                                    if (!data.isCustomer && priceCheck(checkoutGrandTotal, data.minimumPrice, data.maximumPrice, data.priceControl)) {
                                        pushCSS();
                                        if (reqBtn === null) {
                                            createRequestBtnOnCheckout();
                                        }
                                        createModal(modalData);
                                    }
                                } else if (!data.showData.includes('guests') && data.showData.includes('registered')) {
                                    if (
                                        data.isCustomer &&
                                        customerCheck(data.customerGroupID, data.customerGroups, data.groups) &&
                                        priceCheck(checkoutGrandTotal, data.minimumPrice, data.maximumPrice, data.priceControl)
                                    ) {
                                        pushCSS();
                                        if (reqBtn === null) {
                                            createRequestBtnOnCheckout();
                                        }
                                        createModal(modalData);
                                    }
                                }
                            }
                        }
                    });
                }
            }

            function formErrorMessages() {
                if (document.getElementById('o7-name-surname').value === "") {
                    document.querySelector('#o7-name-surname').nextElementSibling.innerText = 'You must enter your first and last name.';
                    document.querySelector('#o7-name-surname').classList.add('has-error');
                    document.querySelector('#o7-name-surname').nextElementSibling.classList.add('is-visible');
                } else {
                    document.querySelector('#o7-name-surname').nextElementSibling.innerText = '';
                    document.querySelector('#o7-name-surname').classList.remove('has-error');
                    document.querySelector('#o7-name-surname').nextElementSibling.classList.remove('is-visible');
                }

                if (document.getElementById('o7-email-address').value === "") {
                    document.querySelector('#o7-email-address').nextElementSibling.innerText = 'You must enter your email address.';
                    document.querySelector('#o7-email-address').classList.add('has-error');
                    document.querySelector('#o7-email-address').nextElementSibling.classList.add('is-visible');
                } else {
                    document.querySelector('#o7-email-address').nextElementSibling.innerText = '';
                    document.querySelector('#o7-email-address').classList.remove('has-error');
                    document.querySelector('#o7-email-address').nextElementSibling.classList.remove('is-visible');
                }

                if (document.getElementById('o7-phone').value === "") {
                    document.querySelector('#o7-phone').nextElementSibling.innerText = 'You must enter your phone number.';
                    document.querySelector('#o7-phone').classList.add('has-error');
                    document.querySelector('#o7-phone').nextElementSibling.classList.add('is-visible');
                } else {
                    document.querySelector('#o7-phone').nextElementSibling.innerText = '';
                    document.querySelector('#o7-phone').classList.remove('has-error');
                    document.querySelector('#o7-phone').nextElementSibling.classList.remove('is-visible');
                }
            }

            function createAlertModal(error) {
                let modalDiv = document.createElement('div'),
                    swalDiv = document.createElement('div'),
                    firstSpan = document.createElement('span'),
                    leftSpan = document.createElement('span'),
                    rightSpan = document.createElement('span'),
                    modalContent = document.createElement('div'),
                    buttonContainerDiv = document.createElement('div'),
                    closeButton = document.createElement('button'),
                    loadingOverlay = document.createElement('div');

                modalDiv.setAttribute('id', 'o7-alert-modal');
                modalDiv.setAttribute('class', 'modal modal--alert modal--small');
                modalDiv.setAttribute('data-reveal', '');
                modalDiv.setAttribute('data-prevent-quick-search-close', '');

                if (error) {
                    swalDiv.setAttribute('class', 'swal2-icon swal2-error swal2-icon-show');
                    firstSpan.setAttribute('class', 'swal2-x-mark');
                    leftSpan.setAttribute('class', 'swal2-x-mark-line-left')
                    rightSpan.setAttribute('class', 'swal2-x-mark-line-right')
                } else {
                    swalDiv.setAttribute('class', 'swal2-icon swal2-success swal2-icon-show');
                    firstSpan.setAttribute('class', 'swal2-x-mark');
                    leftSpan.setAttribute('class', 'swal2-success-line-tip')
                    rightSpan.setAttribute('class', 'swal2-success-line-long')
                }

                firstSpan.append(leftSpan);
                firstSpan.append(rightSpan);
                swalDiv.append(firstSpan);

                modalContent.setAttribute('class', 'modal-content');

                buttonContainerDiv.setAttribute('class', 'button-container');
                closeButton.setAttribute('type', 'button');
                closeButton.setAttribute('class', 'confirm button');
                closeButton.setAttribute('data-reveal-close', '');
                closeButton.innerText = 'OK';
                buttonContainerDiv.append(closeButton);

                loadingOverlay.setAttribute('class', 'loadingOverlay');
                loadingOverlay.style.display = 'none';

                modalDiv.append(swalDiv);
                modalDiv.append(modalContent);
                modalDiv.append(loadingOverlay);

                document.querySelector('body').append(modalDiv);
            }

            function showSwal(data){
                Swal.fire({
                    'icon' : (data.status) ? 'success' : 'warning',
                    'title' : (data.status) ? 'Your Ref ID: #' + data.ref_id : 'An error accourred',
                    'text' : (data.status) ? 'After your request is evaluated, you will be informed by e-mail.' : data.error_message,
                });
            }
        }
    }
})();
